<section class="page-shell">
  <header class="page-header">
    <div class="left">
      <button mat-button routerLink="/dashboard"><mat-icon>arrow_back</mat-icon> Dashboard</button>
      <div class="title-block">
        <p class="eyebrow">Customers</p>
        <h1>Every relationship in one clean view</h1>
        <p class="subtitle">Search, import, or add customers, then tap a row to open full details.</p>
      </div>
    </div>
    <div class="right">
      <button (click)="exportGoogleContacts()" class="ghost-btn" mat-stroked-button><mat-icon>file_download</mat-icon> Export Google Contacts</button>
      <button (click)="importDialog()" class="ghost-btn" mat-stroked-button><mat-icon>file_upload</mat-icon> Import</button>
      <button (click)="showCustomerDialog(null)" class="primary-btn" color="primary" mat-raised-button><mat-icon>person_add</mat-icon> Add Customer</button>
    </div>
  </header>

  <div class="controls">
    <ap-search class="search" placeholder="Search customers" (onChange)="searchChange($event)" (cancelled)="stopSearching()"></ap-search>
    <div class="hint pill">Click a name to edit - tap a phone for Call / SMS QR codes</div>
  </div>

  <div class="alphabet-nav">
    <button
      mat-stroked-button
      class="alpha-btn"
      *ngFor="let letter of alphabetFilters"
      [class.active]="letter === activeAlpha"
      (click)="selectAlpha(letter)">
      {{letter}}
    </button>
  </div>

  <div class="data-card" *ngIf="dataSource">
    <table class="customers" mat-table [dataSource]="dataSource" multiTemplateDataRows>

      <ng-container matColumnDef="name">
        <th class="customer-header" mat-header-cell *matHeaderCellDef>Name</th>
        <td class="customer-column" mat-cell *matCellDef="let element">
          <button class="customer name-btn" type="button" (click)="showCustomerDialog(element)">
            <span class="name">{{element.name}}</span>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th class="customer-header" mat-header-cell *matHeaderCellDef>Phone</th>
        <td class="customer-column" mat-cell *matCellDef="let element">
          <a class="customer phone-link" [class.invalidphone]="!validate_phone_number(element.phone)" [apPhone]="element.phone">
            {{element.phone | phone}}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th class="customer-header" mat-header-cell *matHeaderCellDef>Email</th>
        <td class="customer-column" mat-cell *matCellDef="let element">
          <div class="customer email">{{element.email}}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="googleReview">
        <th class="customer-header" mat-header-cell *matHeaderCellDef>Google Review</th>
        <td class="customer-column" mat-cell *matCellDef="let element">
          <span
            class="review-pill"
            [ngClass]="{
              'review-pill--none': !element.googleReviewStatus || element.googleReviewStatus === 'not_requested',
              'review-pill--requested': element.googleReviewStatus === 'requested',
              'review-pill--complete': element.googleReviewStatus === 'left',
              'review-pill--skip': element.googleReviewStatus === 'do_not_request'
            }">
            {{ getReviewLabel(element.googleReviewStatus) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="remoteID">
        <th class="customer-header" mat-header-cell *matHeaderCellDef>External ID</th>
        <td class="customer-column" mat-cell *matCellDef="let element">
          <div class="customer id">{{element.remoteID}}</div>
        </td>
      </ng-container>

      <tr class="header-row" mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr
        class="customer-row"
        [class.loading]="isRowLoading(element)"
        mat-row
        *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;"></tr>
    </table>
  </div>
</section>
